const scope_0 = require('/home/runner/work/rainer-codes/rainer-codes/.cache/gatsby-mdx/mdx-scopes-dir/117a6dbabf768e6e2606b42fb9c29cd5.js').default;
const scope_1 = require('/home/runner/work/rainer-codes/rainer-codes/.cache/gatsby-mdx/mdx-scopes-dir/5900d07e49923241e79c52fdc097f55d.js').default;
const scope_2 = require('/home/runner/work/rainer-codes/rainer-codes/.cache/gatsby-mdx/mdx-scopes-dir/b4c868f5deb85f767f36afe4169379d0.js').default;
const scope_3 = require('/home/runner/work/rainer-codes/rainer-codes/.cache/gatsby-mdx/mdx-scopes-dir/e43fb7ea8e5c973fc291302acf6043f3.js').default;export default {
  ...scope_0,
...scope_1,
...scope_2,
...scope_3
}